<template lang="pug">
v-expand-transition
  div(v-if="is_show_questions" key="showed")
    v-divider.pt-2
    smart-table(
      v-model="selected"
      :adapter="adapter"
      :headers="headers"
      show-select
    )
      template(#header)
        v-btn.mr-2(@click="answerAll" color="success") Ответить всем
        v-btn(@click="is_show_questions = false" text) Отменить
      template(#value--municipality_id="{ item }")
        v-chip(
          v-if="item.municipality_id"
          text
          label
        ) {{ item.municipality_id }}
        v-chip(v-else text label) Не указано
      template(#value--view="{ item }")
        router-link(:to="`/application/${item.id}`")
          v-icon(color="primary" small) mdi-eye
  div(v-else key="hidden")
    .pa-2
      v-btn(@click="is_show_questions = true" color="accent")
        | Выбрать пользователей
        v-icon mdi-chevron-down

</template>

<script>
import SmartTable from '@/components/SmartTable/index.vue';
import clientQuestionService from '@/services/API/client-questions';

export default {
  components:{
    SmartTable,
  },
  props:{
    projectId: { type:Number, required: true },
    questionCategoryId: { type:Number, required: true },
  },
  data() {
    return {
      selected: [],
      is_show_questions: false,
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Номер заявки',
          value: 'id',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Дата заявки',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'Почта отправителя',
          sortable: true,
          value: 'email',
          searchable: true,
        },
        { text: 'Муниципалитет', value: 'municipality_id', sortable: true },
      ],
    };
  },
  methods:{
    adapter(options) {
      const params = {
        'per-page': options.itemsPerPage,
        'sort': '-id',
        'search[project_id]': this.projectId,
        'search[question_category_id]': this.questionCategoryId,
        'search[status]': 1,
        ...options,
      };

      return clientQuestionService.getAll(params);
    },
    answerAll() {
      this.is_show_questions = false;
      this.$emit('answer-all', this.selected);
      this.selected = [];
    },
  },

};
</script>

<style>

</style>
